export const checkIfObjectEmpty = (object:any) => {
    if (object === undefined || Object.getOwnPropertyNames(object).length === 0) // if the page components object is empty ({}) or undefined
        {
        // {}
        return true; //yes, it is empty
    }else{
        // has something
        return false;
    }
};